<template>
    <div class="referral-findnearby-wrapper">
        <div class="w-25 bg-white d-flex flex-column p-4 h-100">
            <div class="d-flex align-items-center justify-content-between mb-1 pe-2">
                <h6 class="fw-bold m-0">Find Nearby Employees</h6>
                <div>
                    <button class="btn text-primary fw-bold p-0 me-3" @click="clearNearbyEmpFilters()">Clear</button>
                    <button class="btn text-primary fw-bold p-0" @click="handleDone()">Done</button>
                </div>
            </div>
            <div class="ai-line"></div>
            <section class="row pe-2">
                <div class="col-4 pe-0 ps-1">
                    <div class="form-control border-0 text-dark my-2"><strong>Search</strong></div>
                    <div class="form-control border-0 text-dark my-2"><strong>Distance</strong></div>
                    <div class="form-control border-0 text-dark my-2"><strong>Credentials</strong></div>
                </div>
                <div class="col-8 ps-0">
                    <div class="my-2">
                        <input class="form-control" placeholder="Search by Name" v-model="nearbyEmpSearchTerm" />
                    </div>
                    <div class="my-2">
                        <select class="form-control" v-model="nearbyEmpDistance">
                            <option v-for="i in [1, 2, 3, 4, 5]" :id="i" :value="i * 5">{{ i * 5 }} miles</option>
                        </select>
                    </div>
                    <div class="my-2 credentials-filter">
                        <MultiSelectFilter
                            :on-fetch="userCredentialsFetch"
                            :selectedItems="selectedCredentials"
                            v-on:selectedItemsUpdated="selectedItemsUpdated"
                            name="User Credentials"
                            ref="credentialsRef"
                        />
                    </div>
                </div>
            </section>
            <section :class="`nearby-emp-list pe-1 ${userOs == 'Windows' ? 'custom-scrollbar' : ''}`">
                <div
                    v-for="emp of nearbyEmpPanelList"
                    :key="emp.UserDetails.id"
                    :class="`nearby-emp-card mb-2 ${selectedNearbyEmp.id === emp.UserDetails.id ? 'selected' : ''}`"
                    @click="highlightEmpPin(emp.UserDetails.id)"
                >
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="fw-bold">
                            {{ emp.UserDetails.firstName }} {{ emp.UserDetails.lastName }} ({{
                                emp.UserDetails.credentials ? emp.UserDetails.credentials.split(",")[0] : "None"
                            }})
                        </div>
                        <button
                            v-if="isHomeHealth && referralDetails.Demographics.UserId === emp.UserDetails.sourceUserId"
                            class="btn text-success p-0 weight-600"
                        >
                            Assigned
                        </button>
                        <button
                            v-if="isReassignAllowed"
                            class="btn text-primary p-0 weight-600 btn-assign"
                            @click="handleAssignReferral(emp)"
                            :disabled="!isHomeHealth"
                        >
                            Assign
                        </button>
                    </div>
                    <small class="text-muted">{{ emp.UserDetails.distance }} miles away</small>
                    <div class="my-1">
                        D: {{ emp.VisitFrequencyDay }}v/{{ emp.VisitHoursDay }}hr W: {{ emp.VisitFrequencyWeek }}v/{{
                            emp.VisitHoursWeek
                        }}hr
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <ProductPill class="me-2" :product-id="getApplicationId(emp.UserDetails.application)" />
                        <div class="me-2 pill green-pill">Active</div>
                        <small class="text-muted fw-bold">{{ emp.UserDetails.agencyName }}</small>
                    </div>
                </div>
                <div class="text-center py-2" ref="trigger" v-show="pageCount < totalPageCount && showLoading">
                    <i class="fas fa-spinner fa-pulse fa-fw fa-2x"></i>
                    <div>Loading...</div>
                </div>
                <div class="text-center py-2" v-if="pageCount >= totalPageCount && nearbyEmpPanelList.length">
                    Showing {{ totalItemCount }} Employees
                </div>
                <div v-if="!nearbyEmpPanelList.length && !showLoading" class="nearby-emp-list pe-1">
                    No employees found
                </div>
            </section>
            <div class="d-flex justify-content-end">
                <img class="pe-2" src="../../../../img/Axxess_Intelligence_logo_2.svg" alt="" />
                <!-- Hiding premium feature until asked to unhide -->
                <!-- <button class="ai-premium-btn mx-2 mt-2 mb-1">Premium</button> -->
            </div>
            <div class="ai-line"></div>
        </div>
        <div class="flex-grow-1" id="NearbyEmp__VisitMap"></div>
    </div>
</template>

<style src="./FindNearByEmployeesForReferral.scss"></style>
<script src="./FindNearByEmployeesForReferral.ts"></script>
